import React, { useState } from "react";
import "./Clientele.css";
import SEO from "../components/SEO";

const clients = [
  {
    name: "ANDHRA UNIVERSITY, VISAKHAPATNAM",
    category: "Universities",
    image: "./images/logos/ANDHRA-UNIVERSITY-VISAKHAPATNAM.jpg",
    link: "https://www.andhrauniversity.edu.in/",
  },
  {
    name: "Dr.BR AMBEDKAR UNIVERSITY, SRIKAKULAM",
    category: "Universities",
    image: "./images/logos/Dr._B.R._Ambedkar_University,_Srikakulam_logo.png",
    link: "http://www.brau.edu.in/",
  },
  {
    name: "Andhra Kesari University, ONGOLE",
    category: "Universities",
    image: "./images/logos/Andhra-Kesari-University-ONGOLE.jpg",
    link: "https://akuprakasam.ac.in/"
  },
  {
    name: "DAMODARAM SANJIVAYYA NATIONAL LAW UNIVERSITY, VISAKHAPATNAM",
    category: "Universities",
    image: "./images/logos/DAMODARAM-SANJIVAYYA-NATIONAL-LAW-UNIVERSITY-VISAKHAPATNAM.png",
    link: "https://dsnlu.ac.in/",
  },
  {
    name: "SRKR ENGINEERING COLLEGE, BHIMAVARAM",
    category: "Engineering",
    image: "./images/logos/SRKR-ENGINEERING-COLLEGE-BHIMAVARAM.jpg",
    link: "http://srkrec.edu.in/",
  },
  {
    name: "LAKIREDDY BALI REDDY COLLEGE OF ENGINEERING, MYLAVARAM",
    category: "Engineering",
    image: "./images/logos/LAKIREDDY-BALI-REDDY-COLLEGE-OF-ENGINEERING-MYLAVARAM.jpg",
    link: "https://lbrce.ac.in/",
  },
  {
    name: "RAGHAVENDRA INSTITUTE OF PHARMACEUTICAL EDUCATION AND RESEARCH, ANANTAPUR.",
    category: "Pharmacy Colleges",
    image: "./images/logos/RAGHAVENDRA-INSTITUTE-OF-PHARMACEUTICAL-EDUCATION-AND-RESEARCH-ANANTAPUR.jpg",
    link: "https://riper.ac.in/",
  },
  {
    name: "SIET & SIST, PUTTUR.",
    category: "Engineering",
    image: "./images/logos/SIET-SIST-PUTTUR.jpg",
    link: "https://www.sietk.org/",
  },
  {
    name: "MIC COLLEGE, KANCHIKACHERLA.",
    category: "Engineering",
    image: "./images/logos/MIC-COLLEGE-KANCHIKACHERLA.png",
    link: "https://mictech.edu.in/",
  },
  {
    name: "SRI VENKATESA PERUMAL COLLEGE OF ENGINEERING & TECHNOLOGY, PUTTUR.",
    category: "Engineering",
    image: "./images/logos/SRI-VENKATESA-PERUMAL-COLLEGE-OF-ENGINEERING-TECHNOLOGY-PUTTUR.jpg",
    link: "https://svpcet.org/",
  },
  {
    name: "PACE ENGINEERING COLLEGE, ONGOLE.",
    category: "Engineering",
    image: "./images/logos/PACE-ENGINEERING-COLLEGE-ONGOLE.png",
    link: "https://pace.ac.in/",
  },
  {
    name: "JBIET COLLEGE, HYDERABAD.",
    category: "Engineering",
    image: "./images/logos/JBIET-COLLEGE-HYDERABAD.png",
    link: "https://www.jbiet.edu.in/",
  },
  {
    name: "SIR.C.R.REDDY COLLEGE OF ENGINEERING, ELURU.",
    category: "Engineering",
    image: "./images/logos/SIR-C-R-REDDY-COLLEGE-OF-ENGINEERING-ELURU.png",
    link: "https://sircrrengg.ac.in/",
  },
  {
    name: "D.N.R.COLLEGE, BHIMAVARAM.",
    category: "UG & PG Colleges",
    image: "./images/logos/D-N-R-COLLEGE-BHIMAVARAM.jpg",
    link: "https://dnrcollege.org/en/",
  },
  {
    name: "K.G.R.L COLLEGE, BHIMAVARAM.",
    category: "UG & PG Colleges",
    image: "./images/logos/K-G-R-L-COLLEGE-BHIMAVARAM.jpg",
    link: "https://www.kgrlcollege.in/",
  },
  {
    name: "A.S.N.M GOVERNMENT DEGREE COLLEGE,PALAKOLLU",
    category: "UG & PG Colleges",
    image: "./images/logos/A-S-N-M-GOVERNMENT-DEGREE-COLLEGE-PALAKOLLU.jpg",
    link: "https://sriasnmgdcpalakol.ac.in//",
  },
  {
    name: "SIR.C.R.R.COLLEGE, ELURU.",
    category: "UG & PG Colleges",
    image: "./images/logos/SIR-C-R-R-COLLEGE-ELURU.png",
    link: "https://sircrreddycollege.ac.in/",
  },
  {
    name: "SREE KONASEEMA BHANOJI RAMARS COLLEGE, AMALAPURAM.",
    category: "UG & PG Colleges",
    image: "./images/logos/SREE-KONASEEMA-BHANOJI-RAMARS-COLLEGE-AMALAPURAM.png",
    link: "https://www.skbrcollege.org/",
  },
  {
    name: "GOVERNMENT DEGREE COLLEGE, TUNI.",
    category: "UG & PG Colleges",
    image: "./images/logos/GOVERNMENT-DEGREE-COLLEGE-TUNI.jpg",
    link: "https://www.gdctuni.edu.in/pages1/index.php",
  },
  {
    name: "GOVERNMENT COLLEGE FOR WOMEN, SRIKAKULAM.",
    category: "UG & PG Colleges",
    image: "./images/logos/Government-College-for-Women-W-Srikakulam.jpg",
    link: "http://gcwskl.com/",
  },

  {
    name: "Government College For Women(W),Guntur",
    category: "Engineering",
    image: "./images/logos/Government-College-For-Women-W-Guntur.jpg",
    link: "https://gcwguntur.ac.in/"
  },

  {
    name: "ABR Degree College, Repalle ",
    category: "UG & PG Colleges",
    image: "./images/logos/ABR-Degree-College-Bapatla.jpg",
    link: "https://abrgdcrepalle.ac.in/"
  },
  {
    name: "A.M. Reddy Memorial College of Engineering & Technology, Narasaraopet ",
    category: "Engineering",
    image: "./images/logos/A-M-Reddy-Memorial-College-of-Engineering-Technology-Narasaraopet.png",
    link: "https://www.amreddyengineering.ac.in/"
  },
  {
    name: "St. Joseph Dental College,Duggirala",
    category: "Pharmacy Colleges",
    image: "./images/logos/St-Joseph-Dental-College-Duggirala.png",
    link: "https://stjosephdentaleluru.com/"
  },
  {
    name: "Dhanekula Institute of Engineering & Technology, Vijayawada",
    category: "Engineering",
    image: "./images/logos/Dhanekula-Institute-of-Engineering-Technology-Vijayawada.png",
    link: "https://www.diet.ac.in/"
  },
  {
    name: "Dr. V.S. Krishna Government Degree College, Visakhapatnam",
    category: "UG & PG Colleges",
    image: "./images/logos/Dr-V-S-Krishna-Government-Degree-College-Visakhapatnam.jpg",
    link: "https://www.drvskrishnagdc.edu.in/"
  },

  {
    name: "Rajiv Gandhi University of Knowledge Technologies (IIIT), Kadapa",
    category: "Engineering",
    image: "./images/logos/Rajiv-Gandhi-University-of-Knowledge-Technologies-IIIT-Kadapa.jpg",
    link: "https://www.rgukt.in/iiit-kadapa.html"
  },
  {
    name: "D.S. Government Degree College for Women(A), Ongole",
    category: "UG & PG Colleges",
    image: "./images/logos/D-S-Government-Degree-College-for-Women-A--Ongole.jpg",
    link: "https://dsgdcw.ac.in/"
  },
  {
    name: "Rajiv Gandhi University of Knowledge Technologies (IIIT), Ongole",
    category: "Engineering",
    image: "./images/logos/Rajiv-Gandhi-University-of-Knowledge-Technologies-IIIT-Ongole.jpg",
    link: "https://www.rguktong.ac.in/"
  },
  {
    name: "Prakasam Engineering College, kandukur",
    category: "Engineering",
    image: "./images/logos/Prakasam-Engineering-College-kandukur.jpg",
    link: "https://prakasamec.com/"
  },
  {
    name: "Sree Rama Engineering College,Tirupati",
    category: "Engineering",
    image: "./images/logos/Sree_Rama.png",
    link: "https://www.sreerama.ac.in/"
  },

  {
    name: "TRR Government Degree College, Kandukur",
    category: "UG & PG Colleges",
    image: "./images/logos/TRR_DEGREE_COLLEGE.png",
    link: "https://www.gdckandukur.ac.in/"
  },
  {
    name: "Vahini Engineering College, Tiruvuru",
    category: "Engineering",
    image: "./images/logos/Vahini.png",
    link: "https://sreevahini.edu.in/"
  },
  {
    name: "Sri Vasavi Institute of Engineering & Technology, Pedana",
    category: "Engineering",
    image: "./images/logos/Vasavi_logo.png",
    link: "https://www.sviet.edu.in/"
  },
  {
    name: "Vikas Group of Institutions, Vijayawada",
    category: "Engineering",
    image: "./images/logos/Vikas_Groups.jpeg",
    link: "https://www.vikasgroup.edu.in/"
  },
  {
    name: "Vikas College",
    category: "Engineering",
    image: "./images/logos/Vikas-College.jpg",
    link: "https://vikasinstitutionsnunna.org/"
  },
  {
    name: "Visakha Govt. Degree College For Women(W),Vizag",
    category: "UG & PG Colleges",
    image: "./images/logos/Vizag_womens_logo1.png",
    link: "https://www.visakawomenscollege.ac.in/"
  },
  {
    name: "Dr. K.V. Subba Reddy Institute of Pharmacy",
    category: "Pharmacy Colleges",
    image: "./images/logos/KV-Subbhareddy.jpeg",
    link: "https://drkvsrip.ac.in/"
  },
  {
    name: "Mahathi College of Pharmacy",
    category: "Pharmacy Colleges",
    image: "./images/logos/Mahathi-College-Of-Pharmacy.jpg",
    link: "https://mcpm.edu.in/"
  },

  {
    name: "ABR College Of Engineering & Technology, Kanigiri",
    category: "Engineering",
    image: "./images/logos/ABR-College-Of-ENG-TECH.png",
    link: "https://abrcet.edu.in/"
  },

  {
    name: "RIET",
    category: "Engineering",
    image: "./images/logos/RIET.png",
    link: "https://www.rietrjy.co.in/"
  },

  {
    name: "SPACES DEGREE",
    category: "UG & PG Colleges",
    image: "./images/logos/spaces.png",
    link: "https://spacescollege.ac.in/"
  },

  {
    name: "vijaya institute of technology for women",
    category: "Engineering",
    image: "./images/logos/vijayaEngineering.png",
    link: "https://www.vitw.edu.in/"
  },

  {
    name: "vijaya institute of pharmaceutical sciences for women",
    category: "Pharmacy Colleges",
    image: "./images/logos/vijayaPharmacy.png",
    link: "https://vipw.in/"
  },

    {
    name: "SEAT",
    category: "Engineering",
    image: "./images/logos/sidharth-SEAT.png",
    link: "https://siddarthaedu.in/"
  },

];

const categories = [
  "All",
  "Universities",
  "Engineering",
  "UG & PG Colleges",
  "Pharmacy Colleges",
];

const Clientele = () => {
  const [filter, setFilter] = useState("All");

  const filteredClients =
    filter === "All"
      ? clients
      : clients.filter((client) => client.category === filter);

  return (
    <div id="Clientele" className="clientele-wrapper">
      <SEO
        title="Our Clientele & Partners — D Base Solutions Pvt Ltd"
        description="Trusted by over 40+ premier universities, autonomous engineering colleges, and institutions across India including Andhra University, Dr. BR Ambedkar University, SRKR, and LBRCE."
        keywords="D Base Solutions clients, university clients, Andhra University, examination ERP clients, education technology partners"
        canonical="https://dbasesolutions.in/clientele"
        ogImage="/og-clientele.png"
        breadcrumbs={[
          { name: "Home", url: "/" },
          { name: "Clientele", url: "/clientele" }
        ]}
      />
      {/* Background Decorative Shapes */}
      <div className="bg-shape shape-1"></div>
      <div className="bg-shape shape-2"></div>
      <div className="bg-shape shape-3"></div>

      <div className="clientele-content">
        <header className="section-header">
          <h2 className="section-title-main">Our Valued Clientele</h2>
          <p className="section-subtitle">
            Empowering education and innovation across 40+ leading institutions and organizations.
          </p>
        </header>

        {/* Filter Buttons */}
        <div className="category-filter-bar">
          {categories.map((category, index) => (
            <button
              key={index}
              className={`category-pill ${filter === category ? "active-category" : ""}`}
              onClick={() => setFilter(category)}>
              {category}
            </button>
          ))}
        </div>

        {/* Client Grid */}
        <div className="clients-grid-layout">
          {filteredClients.map((client, index) => (
            <div
              key={index}
              className="client-item-card"
              style={{ "--item-index": index }}
            >
              <a href={client.link} target="_blank" rel="noopener noreferrer" style={{ width: '100%', height: '100%', display: 'block' }}>
                <div
                  className="logo-display"
                  style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/${client.image.replace('./', '')})` }}>
                </div>
                <div className="client-info-overlay">
                  <h3 className="client-name-tag">{client.name}</h3>
                  <span className="client-view-link">Visit Website <i className="fas fa-external-link-alt"></i></span>
                </div>
              </a>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Clientele;
